import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const courseSectionDefaultVariants = {}
const courseSectionCompoundVariants = []

const courseSectionSlotNames = [
  [
    "root",
    "course-section__root"
  ],
  [
    "wrapper",
    "course-section__wrapper"
  ],
  [
    "filtersWrapper",
    "course-section__filtersWrapper"
  ],
  [
    "filters",
    "course-section__filters"
  ],
  [
    "goto",
    "course-section__goto"
  ]
]
const courseSectionSlotFns = /* @__PURE__ */ courseSectionSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, courseSectionDefaultVariants, getSlotCompoundVariant(courseSectionCompoundVariants, slotName))])

const courseSectionFn = memo((props = {}) => {
  return Object.fromEntries(courseSectionSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const courseSectionVariantKeys = []
const getVariantProps = (variants) => ({ ...courseSectionDefaultVariants, ...compact(variants) })

export const courseSection = /* @__PURE__ */ Object.assign(courseSectionFn, {
  __recipe__: false,
  __name__: 'courseSection',
  raw: (props) => props,
  variantKeys: courseSectionVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, courseSectionVariantKeys)
  },
  getVariantProps
})